import type { ForwardedRef } from 'react';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@kcd/design-system';

import Image, { AutoImageWrapper } from '~/components/Image';
import Overlay from '~/components/Overlay';

import { CloseIcon } from '~/assets/icons';

export type RefProps = {
  onOpen: () => void;
};

const PosQRModal = forwardRef((_, ref: ForwardedRef<RefProps>) => {
  const router = useRouter();
  const [opened, setOpened] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      onOpen: () => setOpened(true),
    };
  });

  return (
    <Overlay opened={opened} onClick={() => setOpened(false)}>
      <div className="relative flex h-[480px] w-[336px] flex-col justify-between rounded-3xl bg-gray-000 p-20">
        <CloseIcon
          className="absolute right-20 top-24 w-24 text-gray-000"
          onClick={() => setOpened(false)}
        />
        <div>
          <h3
            className="font-bold mt-48 text-center text-gray-000"
            style={{ fontSize: '22px' }}
          >
            휴대폰 카메라로 QR코드를
            <br />
            촬영하여 발주를 완료할 수 있어요
          </h3>
          <p
            className="font-[500] mt-8 text-center leading-[18px] text-gray-000"
            style={{ fontSize: '14px' }}
          >
            포스에 로그인된 계정과
            <br />
            휴대폰에 로그인된 계정이 다를경우
            <br />
            장바구니에 담긴 상품이 달라질 수 있어요.
          </p>
          <div className="flex justify-center pt-[42px]">
            <Image
              src="/static/images/pos/qr.png"
              alt="qr"
              width={116}
              height={116}
            />
          </div>
        </div>
        <AutoImageWrapper className="absolute -top-136 left-[142px] h-[295px] !w-[111px]">
          <Image src="/static/images/pos/card.png" alt="card" layout="fill" />
        </AutoImageWrapper>
        <AutoImageWrapper className="absolute bottom-[-82px] left-[100px] w-[38px]">
          <Image src="/static/images/pos/coin.png" alt="coin" layout="fill" />
        </AutoImageWrapper>
        <AutoImageWrapper className="absolute left-[-65px] top-[106px] h-[295px] !w-[78px]">
          <Image src="/static/images/pos/left.png" alt="left" layout="fill" />
        </AutoImageWrapper>
        <AutoImageWrapper className="absolute right-[-138px] top-[145px] h-[295px] !w-[138px]">
          <Image src="/static/images/pos/right.png" alt="right" layout="fill" />
        </AutoImageWrapper>

        <Button onClick={() => router.push('/app')}>홈으로 가기</Button>
      </div>
    </Overlay>
  );
});

PosQRModal.displayName = 'PosQRModal';

export default PosQRModal;
